import React, { useMemo } from 'react';
import { Bed } from '@phosphor-icons/react';

export const ReservationsTable = ({ reservations }) => {
  const totalRevenue = useMemo(() => {
    if (!reservations) return '0.00';
    return reservations.reduce((sum, r) => sum + (r.total_cost || 0), 0).toFixed(2);
  }, [reservations]);

  if (!reservations || reservations.length === 0) return null;

  return (
    <div className="mt-8 bg-[#161616] border border-[#262626] rounded-lg p-6" data-testid="reservations-section">
      <div className="flex items-center gap-3 mb-4">
        <Bed size={22} className="text-[#0096FF]" />
        <h3 className="text-lg font-bold text-white" style={{fontFamily: 'Outfit'}}>
          Stalls & RV Reservations
          <span className="text-[#9E9E9E] text-sm font-normal ml-2">({reservations.length})</span>
        </h3>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-[#262626]">
              <th className="text-left text-xs text-[#9E9E9E] font-semibold p-3">Rider</th>
              <th className="text-left text-xs text-[#9E9E9E] font-semibold p-3">Email</th>
              <th className="text-center text-xs text-[#9E9E9E] font-semibold p-3">Stalls</th>
              <th className="text-center text-xs text-[#9E9E9E] font-semibold p-3">RV Hookups</th>
              <th className="text-right text-xs text-[#9E9E9E] font-semibold p-3">Total</th>
              <th className="text-center text-xs text-[#9E9E9E] font-semibold p-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {reservations.map((res, i) => (
              <tr key={i} className="border-b border-[#1a1a1a] hover:bg-[#0A0A0A]/50" data-testid={`reservation-row-${i}`}>
                <td className="p-3 text-white text-sm font-semibold">{res.rider_name}</td>
                <td className="p-3 text-[#9E9E9E] text-sm">{res.rider_email || '-'}</td>
                <td className="p-3 text-center text-white text-sm font-bold">{res.stalls || 0}</td>
                <td className="p-3 text-center text-white text-sm font-bold">{res.rv_hookups || 0}</td>
                <td className="p-3 text-right text-[#34C759] text-sm font-bold">${(res.total_cost || 0).toFixed(2)}</td>
                <td className="p-3 text-center">
                  <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                    res.payment_status === 'PAID' ? 'bg-[#34C759]/15 text-[#34C759]' : 'bg-[#FF9500]/15 text-[#FF9500]'
                  }`}>{res.payment_status || 'PENDING'}</span>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="border-t border-[#262626]">
              <td className="p-3 text-[#9E9E9E] text-sm font-bold" colSpan={2}>Totals</td>
              <td className="p-3 text-center text-[#0096FF] text-sm font-bold">{reservations.reduce((s, r) => s + (r.stalls || 0), 0)}</td>
              <td className="p-3 text-center text-[#0096FF] text-sm font-bold">{reservations.reduce((s, r) => s + (r.rv_hookups || 0), 0)}</td>
              <td className="p-3 text-right text-[#34C759] text-sm font-bold">${totalRevenue}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};
